<div class="notification-details-container">
  
    <mat-card class="notification-recepient-list" style="box-shadow: none;">

      <div class="notification-header">

        <div class="notification-list-title">Recipients</div>

        <div class="notification-details-search">
          <dl-notification-search></dl-notification-search>
          <div title="Click to open filter Diaolg" class="notification-details-filter-icon" (click)="filterData()">
            <i class="one-icons filter-icon">filter</i>
            <span class="filter-text">Filter</span>
          </div>
        </div>

        <div style="text-align: right;" title="Click to configure columns">
          <i class="one-icons" [matMenuTriggerFor]="menu" #menuTrigger style="cursor: pointer;">settings</i>
        </div>

        <mat-menu #menu="matMenu" class="columns-display-menu">
          <div xPosition="before" oneMenu>

            <mat-card class="one-card-flat" oneCard style="position:relative">

              <div class="column-header" (click)="$event.stopPropagation()">
                <div class="column-title">Show/Hide columns</div>
              </div>

              <one-table>
                <one-table-content (click)="$event.stopPropagation()">
                  <mat-table [dataSource]="dataSource" matTableExporter matSort multiTemplateDataRows #exporter="matTableExporter" class="configure-columns-table">
                    <ng-container matColumnDef="select">
                      <mat-header-cell *matHeaderCellDef>
                        <mat-checkbox 
                          (change)="$event ? masterToggle($event) : null"
                          [checked]="selection.hasValue() && isAllSelected($event)"
                          [indeterminate]="selection.hasValue() && !isAllSelected($event)">
                        </mat-checkbox>
                      </mat-header-cell>

                      <mat-cell (click)="handleChecked(row)" *matCellDef="let row">
                        <mat-checkbox (change)="$event ? selection.toggle(row) : null; selectedRow = row"
                          (click)="$event.stopPropagation()" [checked]="selection.isSelected(row)" [disabled]="row.disabled">
                        </mat-checkbox>
                      </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="allColumns">
                      <mat-header-cell *matHeaderCellDef>All Columns</mat-header-cell>
                      <mat-cell *matCellDef="let element">
                        <div class="truncate-text">{{element.key}}</div>
                      </mat-cell>
                    </ng-container>
            
                    <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
                    <mat-row 
                      *matRowDef="let row; columns: displayedColumns"
                      class="one-element-row"
                      [ngClass]="{ checked: selection.isSelected(row), disabled: row.disabled }">
                    </mat-row>
                  </mat-table>
                </one-table-content>
            
                <one-table-footer class="table-footer">
                  <div>
                    <button color="primary" mat-flat-button (click)="getSelectedColumns()">Apply</button>
                  </div>
                </one-table-footer>
              </one-table>

            </mat-card>

          </div>
        </mat-menu>

      </div>

    </mat-card>

    <dl-notification-recipients-table 
      [isSetCom]="isSetCom" 
      [notificationLabel]="notificationLabel" 
      [contactDetails]="contactDataObj" 
      [notificationDetails]="notificationDataObj" 
      [selectedRecepientColumns]="selectedColumns"
      [accDataObj]="accDataObj"
      ></dl-notification-recipients-table>
  
</div>